import React from 'react';
import { useTranslation } from 'react-i18next';
import { DonutChart } from '@fluentui/react-charting';
import './DonutFluentWidget.css';

const DonutFluentWidget = ({ data, config }) => {
    const { t } = useTranslation();

    console.log('🍩 DonutFluentWidget received:', { data, config });

    // Extract configuration
    const nameKey = config?.config?.nameKey || config?.nameKey || 'name';
    const valueKey = config?.config?.valueKey || config?.valueKey || 'value';
    const innerRadius = config?.config?.innerRadius || config?.innerRadius || 50;

    // Ensure data is an array
    const chartData = Array.isArray(data) ? data : [];

    if (chartData.length === 0) {
        return (
            <div className="donut-fluent-empty">
                <p>{t('NO_DATA_AVAILABLE')}</p>
            </div>
        );
    }

    // Transform data for Fluent UI DonutChart
    const fluentChartData = {
        chartTitle: t(config?.titleKey || config?.title) || 'Distribution',
        chartData: chartData.map((item, index) => ({
            legend: item[nameKey] || `Item ${index + 1}`,
            data: item[valueKey] || 0,
            color: getColorByIndex(index)
        }))
    };

    // Color palette — matches HeedifyTheme.css chart colors (--chart-color-1 through 8)
    function getColorByIndex(index) {
        const colors = [
            '#00A4A6', // Teal   — brand accent (primary)
            '#1B3A6B', // Navy   — brand primary
            '#8B5CF6', // Violet
            '#F97316', // Orange
            '#EF4444', // Red
            '#06B6D4', // Cyan
            '#10b981', // Green
            '#FFC700', // Amber
        ];
        return colors[index % colors.length];
    }

    return (
        <div className="donut-fluent-widget">
            <DonutChart
                data={fluentChartData}
                innerRadius={innerRadius}
                height={280}
                width={280}
                valueInsideDonut={fluentChartData.chartData.reduce((sum, item) => sum + item.data, 0).toString()}
                legendsOverflowText="More"
                hideLegend={false}
                enableReflow={true}
            />
        </div>
    );
};

export default DonutFluentWidget;
